import { CredentialType } from '../shared';
import type { Credential } from './types';

export const STUB_CREDENTIALS: Credential[] = [
  {
    name: 'credentials/cred-aws-hsbc-prod',
    uid: 'cred-1111-1111-1111-111111111111',
    displayName: 'HSBC AWS Production',
    credentialType: CredentialType.CREDENTIAL_TYPE_AWS,
    maskedValues: {
      accessKeyId: '********',
      secretAccessKey: '********',
      region: 'us-east-1',
    },
    createTime: '2024-01-05T10:00:00Z',
    updateTime: '2024-02-01T14:30:00Z',
  },
  {
    name: 'credentials/cred-ssh-hsbc-sftp',
    uid: 'cred-2222-2222-2222-222222222222',
    displayName: 'HSBC SFTP SSH Key',
    credentialType: CredentialType.CREDENTIAL_TYPE_SSH,
    maskedValues: {
      username: 'hsbc-sftp-user',
      keyFilePath: 'hsbc/id_rsa',
      knownHostsFile: 'hsbc/known_hosts',
    },
    createTime: '2024-01-05T10:15:00Z',
    updateTime: '2024-02-01T14:30:00Z',
  },
  {
    name: 'credentials/cred-aws-smbc-emea',
    uid: 'cred-3333-3333-3333-333333333333',
    displayName: 'SMBC EMEA AWS',
    credentialType: CredentialType.CREDENTIAL_TYPE_AWS,
    maskedValues: {
      accessKeyId: '********',
      secretAccessKey: '********',
      region: 'eu-west-1',
    },
    createTime: '2024-01-10T09:00:00Z',
    updateTime: '2024-02-05T11:00:00Z',
  },
  {
    name: 'credentials/cred-ssh-smbc-emea',
    uid: 'cred-4444-4444-4444-444444444444',
    displayName: 'SMBC EMEA SFTP Key',
    credentialType: CredentialType.CREDENTIAL_TYPE_SSH,
    maskedValues: {
      username: 'smbc-emea-user',
      password: '********',
      knownHostsFile: 'smbc-emea/known_hosts',
    },
    createTime: '2024-01-10T09:15:00Z',
    updateTime: '2024-02-05T11:00:00Z',
  },
  {
    name: 'credentials/cred-gcp-truist',
    uid: 'cred-5555-5555-5555-555555555555',
    displayName: 'Truist GCP Service Account',
    credentialType: CredentialType.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT,
    maskedValues: {
      credentialFilePath: 'truist/gcp-sa.json',
    },
    createTime: '2023-10-20T08:00:00Z',
    updateTime: '2024-01-15T10:00:00Z',
  },
  {
    name: 'credentials/cred-aws-bbva',
    uid: 'cred-6666-6666-6666-666666666666',
    displayName: 'BBVA AWS Credentials',
    credentialType: CredentialType.CREDENTIAL_TYPE_AWS,
    maskedValues: {
      accessKeyId: '********',
      secretAccessKey: '********',
      region: 'us-west-2',
    },
    createTime: '2024-01-25T12:00:00Z',
    updateTime: '2024-02-10T08:00:00Z',
  },
  {
    name: 'credentials/cred-azure-santander',
    uid: 'cred-8888-8888-8888-888888888888',
    displayName: 'Santander Azure SP',
    credentialType: CredentialType.CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL,
    maskedValues: {
      tenantId: '********',
      clientId: '********',
      clientSecret: '********',
    },
    createTime: '2024-02-01T09:00:00Z',
    updateTime: '2024-02-15T14:00:00Z',
  },
  {
    name: 'credentials/cred-aws-bnp',
    uid: 'cred-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    displayName: 'BNP Paribas AWS',
    credentialType: CredentialType.CREDENTIAL_TYPE_AWS,
    maskedValues: {
      accessKeyId: '********',
      secretAccessKey: '********',
      region: 'eu-central-1',
    },
    createTime: '2024-02-10T08:00:00Z',
    updateTime: '2024-02-25T10:00:00Z',
  },
  {
    name: 'credentials/cred-ssh-bnp',
    uid: 'cred-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    displayName: 'BNP SFTP SSH Key',
    credentialType: CredentialType.CREDENTIAL_TYPE_SSH,
    maskedValues: {
      username: 'bnp-sftp-user',
      keyFilePath: 'bnp/id_rsa',
      knownHostsFile: 'bnp/known_hosts',
    },
    createTime: '2024-02-10T08:15:00Z',
    updateTime: '2024-02-25T10:00:00Z',
  },
  {
    name: 'credentials/cred-gcp-barclays',
    uid: 'cred-cccc-cccc-cccc-cccccccccccc',
    displayName: 'Barclays GCP SA',
    credentialType: CredentialType.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT,
    maskedValues: {
      credentialFilePath: 'barclays/gcp-sa.json',
    },
    createTime: '2024-02-15T09:00:00Z',
    updateTime: '2024-03-01T11:00:00Z',
  },
  {
    name: 'credentials/cred-aws-citi',
    uid: 'cred-eeee-eeee-eeee-eeeeeeeeeeee',
    displayName: 'Citibank AWS Prod',
    credentialType: CredentialType.CREDENTIAL_TYPE_AWS,
    maskedValues: {
      accessKeyId: '********',
      secretAccessKey: '********',
      region: 'us-east-2',
    },
    createTime: '2024-02-25T08:00:00Z',
    updateTime: '2024-03-10T14:00:00Z',
  },
  {
    name: 'credentials/cred-ssh-citi',
    uid: 'cred-ffff-ffff-ffff-ffffffffffff',
    displayName: 'Citibank SFTP Key',
    credentialType: CredentialType.CREDENTIAL_TYPE_SSH,
    maskedValues: {
      username: 'citi-sftp-user',
      keyFilePath: 'citi/id_rsa',
      knownHostsFile: 'citi/known_hosts',
    },
    createTime: '2024-02-25T08:15:00Z',
    updateTime: '2024-03-10T14:00:00Z',
  },
  {
    name: 'credentials/cred-azure-wells',
    uid: 'cred-1010-1010-1010-101010101010',
    displayName: 'Wells Fargo Azure',
    credentialType: CredentialType.CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL,
    maskedValues: {
      tenantId: '********',
      clientId: '********',
      clientSecret: '********',
    },
    createTime: '2024-03-01T09:00:00Z',
    updateTime: '2024-03-15T11:00:00Z',
  },
  {
    name: 'credentials/cred-gcp-usbank',
    uid: 'cred-2222-3333-4444-555566667777',
    displayName: 'US Bank GCP SA',
    credentialType: CredentialType.CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT,
    maskedValues: {
      credentialFilePath: 'usbank/gcp-sa.json',
    },
    createTime: '2024-03-10T08:00:00Z',
    updateTime: '2024-03-25T10:00:00Z',
  },
];
